import { useMemo, useState } from "react";

import { PhoneArrowUpRightIcon } from "@heroicons/react/24/outline";
import Form from "V2.0/components/Form";
import Joi from "joi-browser";
import {
  sheetURLFieldSchema,
  sheetURLFieldTemplate,
} from "V2.0/HomePages/HomeCampaign/bulkUpload/fields/sheetURLField";
import { triggerTypeField } from "../../common/fields";
import { csvFieldSchema, csvFieldTemplate } from "../../common/CSVField";

export default function BulkCallCampaignForm(props) {
  const {
    createBulkCampaign,
    onClose,
    loading,
    setLoading,
    fromNumber,
    assistantId,
    name,
    description,
    ignorePreviousCampaigns,
    source,
    rotateNumbers,
  } = props;

  const inputField = {
    name,
    description,
    triggerType: "",
    campaignType: "call",
    assistantId,
    ignorePreviousCampaigns,
    ...(source === "Sheet" ? { sheetURL: "" } : { csvFile: "" }),
    ...(rotateNumbers ? { rotateNumbers } : { fromNumber }),
  };

  const [errorMessage] = useState({});

  const template = useMemo(() => {
    if (source === "Sheet") {
      return [sheetURLFieldTemplate, triggerTypeField];
    }

    return [csvFieldTemplate, triggerTypeField];
  }, [source]);

  const schema = {
    name: Joi.string().required().label("Campaign Name"),
    description: Joi.string().allow(null, "").label("Campaign Description"),
    triggerType: Joi.string().required().label("Trigger Type"),
    campaignType: Joi.string().required().label("Campaign Type"),
    assistantId: Joi.string().required(),
    ignorePreviousCampaigns: Joi.boolean(),
    ...(source === "Sheet" ? sheetURLFieldSchema  : csvFieldSchema),
    ...(rotateNumbers
      ? { rotateNumbers: Joi.boolean().required().label("Rotate Numbers") }
      : {
          fromNumber: Joi.string()
            .regex(/^\+?[0-9]+$/)
            .required()
            .label("From Number"),
        }),
  };

  function handleSubmit(data) {
    const { csvFile, ...rest } = data;

    const payload =
      source === "CSV" ? { ...rest, contacts: JSON.parse(csvFile) } : data;

    createBulkCampaign(payload);
  }

  return (
    <Form
      key={JSON.stringify(inputField)}
      errorMessage={errorMessage}
      inputField={inputField}
      template={template}
      schema={schema}
      buttonInfo={{
        style: "",
        buttons: "2",
        // primaryLabel: "Start", // plain string label — replaced with icon+text matching the
        // channel, per Frontend's pattern (bulk-campaign-report-ui-port, Task 7)
        primaryLabel: (
          <>
            <PhoneArrowUpRightIcon className="size-4" />
            Start Call Campaign
          </>
        ),
        secondaryLabel: "Cancel",
      }}
      onSubmit={handleSubmit}
      loading={loading}
      setLoading={setLoading}
      handleSecondary={onClose}
    />
  );
}
